import {
  BpAnnotation,
  BpBarcode,
  BpCode,
  BpIdNumber,
  BpMobilePhone,
  BpNumerical,
  BpPeople,
  BpTime,
  BsBattery,
  BsBatteryFull,
  BsBatteryHalf,
  FaMapMarkerAlt,
  MdPendingActions,
  MdWifi,
  MdWifiOff,
} from '@bymason-private/legacy-pattern-components';

export function DetailItemIcon({ type }: DetailIconProps) {
  switch (type) {
    case 'pending':
      return <MdPendingActions fontSize='1em' />;
    case 'api':
      return <BpCode fontSize='inherit' />;
    case 'batteryEmpty':
      return <BsBattery fontSize='1em' />;
    case 'batteryFull':
      return <BsBatteryFull fontSize='1em' />;
    case 'batteryHalf':
      return <BsBatteryHalf fontSize='1em' />;
    case 'createdAt':
    case 'date':
      return <BpTime fontSize='inherit' />;
    case 'devices':
      return <BpMobilePhone fontSize='inherit' />;
    case 'groups':
      return <BpPeople fontSize='inherit' />;
    case 'id':
      return <BpIdNumber fontSize='inherit' />;
    case 'imei':
      return <BpBarcode fontSize='inherit' />;
    case 'description':
    case 'name':
      return <BpAnnotation fontSize='inherit' />;
    case 'location':
      return <FaMapMarkerAlt fontSize='1em' />;
    case 'online':
      return <MdWifi fontSize='1em' />;
    case 'offline':
      return <MdWifiOff fontSize='1em' />;
    case 'serialnumber':
      return <BpNumerical fontSize='inherit' />;
    default:
      return null;
  }
}

export type BatteryDetailItemType = 'batteryEmpty' | 'batteryFull' | 'batteryHalf';

export type DetailItemType =
  | 'api'
  | 'createdAt'
  | 'date'
  | 'description'
  | 'devices'
  | 'groups'
  | 'id'
  | 'imei'
  | 'location'
  | 'name'
  | 'offline'
  | 'online'
  | 'pending'
  | 'serialnumber'
  | BatteryDetailItemType;

export interface DetailIconProps {
  type?: DetailItemType;
}
